import { useState, useEffect } from "react"
import axios from "axios"
import { RotatingLines } from "react-loader-spinner"

function OpenAI({ flag, domanda }) {

    const [rispostaAI, setRispostaAI] = useState({ risposta: null })
    const [loadingAI, setLoadingAI] = useState(false)

    useEffect(() => {
        const openAI = async () => {
            setLoadingAI(true)
            try {
                const response = await axios.post('/api/chat', {
                    messaggioUtente: domanda
                })
                setRispostaAI({ risposta: response.data.risposta })
            } catch (error) {
                console.error("Errore di connessione con Axios:", error)
                setRispostaAI({ ...rispostaAI, risposta: "Impossibile connettersi al server." })
            }
            finally { setLoadingAI(false) }
        }
        if (flag === 'primoRispostaAI') openAI()
    }, [flag])

    return (<>
        <div className="visualDettagli homePadding" id="rispostaAI" style={{ top: `${flag === 'primoRispostaAI' ? '0' : '120%'}` }
        }>
            <div style={{ height: 'auto' }}>
                <img src={require("../../image/icons8-chiudi-macos-32.png")} alt='' width={'10px'} onClick={() => {
                    setRispostaAI({ risposta: null }); window.history.back()
                }} style={{ position: 'sticky', top: '0', width: '40px', cursor: 'pointer' }}
                />
                {loadingAI ?
                    <div className='mt-5'>
                        <RotatingLines strokeColor='silver' strokeWidth='5' animationDuration='5' width='26' />
                        <span> cerco informazioni per <i>{domanda}</i></span>
                    </div>
                    :
                    <div className='mt-3'>
                        <p>Rispondo a <i>{domanda}</i></p>
                        <p className='mt-4'>{rispostaAI.risposta}...</p>
                        <button className='float-end' style={{ cursor: 'pointer' }}
                            onClick={() => {
                                setRispostaAI({ risposta: null }); window.history.back()
                            }}>
                            indietro
                        </button>
                    </div>
                }
            </div>
        </div >
    </>)
}
export default OpenAI